import { Box, Link, SpaceBetween } from '@amzn/awsui-components-core';
import {
  colorBackgroundHomeHeader,
  colorTextBodySecondary,
  colorTextHomeHeaderDefault,
  spaceScaledXs,
} from '@amzn/awsui-design-tokens/polaris';

export default function Footer() {
  return (
    <footer
      id="page-footer"
      style={{
        backgroundColor: colorBackgroundHomeHeader,
        color: colorTextHomeHeaderDefault,
        padding: `${spaceScaledXs} ${spaceScaledXs}`,
      }}
    >
      <SpaceBetween direction="horizontal" size="xs">
        <Link href="https://aws.amazon.com/privacy/" external color="inverted" fontSize="body-s">
          Privacy
        </Link>
        <Box color="text-body-secondary" variant="small">
          |
        </Box>
        <Link href="https://aws.amazon.com/terms/" external color="inverted" fontSize="body-s">
          Site terms
        </Link>
        <Box color="text-body-secondary" variant="small">
          |
        </Box>
        <Box variant="small" color="inherit">
          <span style={{ color: colorTextBodySecondary }}>
            © 2008 - 2026 Amazon Web Services, Inc. or its affiliates. All rights reserved. Contact
            us
          </span>
        </Box>
      </SpaceBetween>
    </footer>
  );
}
